module.exports = __webpack_public_path__ + "img/img_family_03.86480b39.svg";